import { Navigate } from 'react-router-dom';

/** New gallery images are added from the gallery list via modal. */
export default function GalleryNew() {
  return (
    <Navigate to="/admin/dashboard/gallery" replace state={{ openNewGalleryItem: true }} />
  );
}
